import React from 'react'
import { formatLondonTime } from 'components/Common/utils'

interface FormattedDateProps {
  children: number | Date | string
}

const FormattedDate = (props: FormattedDateProps) => (
  <div className='order-datetime'>
    {props.children ? (
      <>
        <p className='date'>{formatLondonTime(props.children, 'DD/MM/YYYY')}</p>
        <p className='time'>{formatLondonTime(props.children, 'hh:mm A')}</p>
      </>
    ) : (
      '--'
    )}
  </div>
)

export default FormattedDate
